<div>
	<div class="mb-10">Set username</div>
	<form
		(ngSubmit)="onSubmit(integrationsForm)"
		#integrationsForm="ngForm"
		class="flex flex-col justify-center items-center"
	>
		<mat-form-field class="example-full-width mr-10">
			<input
				type="string"
				matInput
				placeholder="Teranet Username"
				[(ngModel)]="teranetUsername"
				[name]="teranetUsernameFormValue"
				required
			/>
		</mat-form-field>

		<button
			*ngIf="savedInitialUsername != teranetUsername"
			type="submit"
			mat-stroked-button
			color="primary"
		>
			Save
		</button>
	</form>
</div>
